/**
 * Per-unit trim eligibility (owner, RS-16, 2026-08-29):
 * "Base cabinets should never have crown, just base trim. Uppers have crown,
 * no base."
 *
 * Anchors are the maintained structural class: countertop = base, top =
 * upper, floor = tall/ordinary. A position can contain a stack, so eligibility
 * asks whether ANY unit at that footprint can carry the selected trim.
 */
export function stackHasCrownTrim(units) {
  return (Array.isArray(units) ? units : []).some((unit) => unit?.anchor !== 'countertop');
}

export function stackHasBaseTrim(section, units) {
  if (section?.bottomShelf === false) return false;
  return (Array.isArray(units) ? units : []).some((unit) => unit?.anchor !== 'top');
}
